module.exports = __webpack_public_path__ + "client-static/img/logo_linkaja.f496792.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_linkaja.png
// module id = aDb8
// module chunks = 2